"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.initGraphene = exports.blizzardGraphene = exports.SUCCESS = exports.FOCUSED = exports.STARTUP_TYPE = exports.SPECTRUM_INVALID_REGION = exports.COF_UNSUPPORTED_CONFIG_TYPE = exports.COF_EMPTY_CONFIG_VALUE = exports.COF_EMPTY_CONFIG = exports.COF_FAILURE = exports.UPLOAD_BODY_SIZE = exports.UPLOAD_FAIL_FROM_BAD_CONFIGS = exports.ON_CLOSE = exports.ON_OPEN = exports.NETWORK_REQUEST_ATTEMPTS_COUNT = exports.NETWORK_REQUEST_LATENCY_MS = exports.NETWORK_REQUEST = exports.EVENTS_FLUSHED = exports.LOG_EVENT_NO_FRAME_START_AT_FLUSH = exports.LOG_EVENT_EMPTY_BATCH_AT_FLUSH = exports.LOG_EVENT_FLUSH_ERROR = exports.LOG_EVENT_APPEND_ERROR = exports.LOG_EVENT_ILLEGAL_ITEMS = exports.LOG_EVENT_FLUSH = exports.LOG_EVENT_BATCH_LIFETIME_TILL_FLUSH_MS = exports.LOG_EVENT_BATCHING_BUFFER_SIZE = exports.LOG_EVENT_BUFFER_SIZE = exports.LOG_EVENT_BEFORE_FRAME_START = exports.LOG_FRAME_START = exports.LOG_EVENT = exports.INIT_DURATION_MILLIS = void 0;
var graphene_1 = require("@snapchat/graphene");
var BrowserNetworkHandler_1 = __importDefault(require("@snapchat/graphene/lib/network/BrowserNetworkHandler"));
var web_1 = __importDefault(require("@snapchat/graphene/lib/config/web"));
var environment_1 = require("./environment");
var isNil_1 = __importDefault(require("lodash/isNil"));
var omitBy_1 = __importDefault(require("lodash/omitBy"));
exports.INIT_DURATION_MILLIS = "init_duration_millis";
exports.LOG_EVENT = "log_event";
exports.LOG_FRAME_START = "log_frame_start";
exports.LOG_EVENT_BEFORE_FRAME_START = "log_event_before_frame_start";
exports.LOG_EVENT_BUFFER_SIZE = "log_event_buffer_size";
exports.LOG_EVENT_BATCHING_BUFFER_SIZE = "log_event_batching_buffer_size";
exports.LOG_EVENT_BATCH_LIFETIME_TILL_FLUSH_MS = "log_event_batch_lifetime_till_flush_ms";
exports.LOG_EVENT_FLUSH = "log_event_flush";
exports.LOG_EVENT_ILLEGAL_ITEMS = "log_event_ILLEGAL_items";
exports.LOG_EVENT_APPEND_ERROR = "log_event_append_error";
exports.LOG_EVENT_FLUSH_ERROR = "log_event_flush_error";
exports.LOG_EVENT_EMPTY_BATCH_AT_FLUSH = "log_event_empty_batch_at_flush";
exports.LOG_EVENT_NO_FRAME_START_AT_FLUSH = "log_event_no_frame_start_at_flush";
exports.EVENTS_FLUSHED = "events_flushed";
exports.NETWORK_REQUEST = "network_request";
exports.NETWORK_REQUEST_LATENCY_MS = "network_request_latency_ms";
exports.NETWORK_REQUEST_ATTEMPTS_COUNT = "network_request_attempts_count";
exports.ON_OPEN = "on_open";
exports.ON_CLOSE = "on_close";
exports.UPLOAD_FAIL_FROM_BAD_CONFIGS = "upload_fail_from_bad_configs";
exports.UPLOAD_BODY_SIZE = "upload_body_size";
exports.COF_FAILURE = "cof_failure";
exports.COF_EMPTY_CONFIG = "cof_empty_config";
exports.COF_EMPTY_CONFIG_VALUE = "cof_empty_config_value";
exports.COF_UNSUPPORTED_CONFIG_TYPE = "cof_unsupported_config_type";
exports.SPECTRUM_INVALID_REGION = "spectrum_invalid_region";
exports.STARTUP_TYPE = "startup_type";
exports.FOCUSED = "focused";
exports.SUCCESS = "success";
exports.blizzardGraphene = new graphene_1.Graphene();
function initGraphene(metricsAppId) {
    var _a;
    var env = (0, environment_1.getAppEnvironment)();
    exports.blizzardGraphene.initialize({
        networkHandler: new BrowserNetworkHandler_1["default"]((0, web_1["default"])({
            partitionName: graphene_1.PARTITION.BLIZZARD,
            flavor: (_a = env.appBuild) !== null && _a !== void 0 ? _a : "unknown",
            defaultDimensions: (0, omitBy_1["default"])({
                app: env.application,
                appType: env.appType,
                appVersion: env.appVersion,
                metricsAppId: metricsAppId
            }, isNil_1["default"])
        }))
    });
}
exports.initGraphene = initGraphene;
//# sourceMappingURL=grapheneMetrics.js.map